import React, { useState, useEffect, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Translate, withLocalize } from 'react-localize-redux'
import { IconButton, Table, TableBody } from '@material-ui/core'
import { Card } from 'components'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import {
  SubLink,
  CategoryForManageCategories,
  LanguageSelectorForAdmins,
} from 'containers'
import { drills } from 'redux/modules'
import { createSubUrl } from 'utils/urlConstructor'
import PropTypes from 'prop-types'

import { ACTIVITIES_ROUTE } from 'constants/routes'

const MAX_DEPTH = 2

const DrillsCategoriesContainer = ({
  location: { fromUrl },
  match,
  drillsCategories,
  createDrillsCategory,
  updateDrillsCategory,
  deleteDrillsCategory,
  activeLanguage,
  clubUuid,
}) => {
  const [drillsCategoriesState, changeDrillsCategoriesState] = useState([])

  useEffect(() => {
    changeDrillsCategoriesState(drillsCategories)
  }, [drillsCategories])

  const linkBack = fromUrl || createSubUrl(match, ACTIVITIES_ROUTE)

  const addNewCategory = (parentId) => (title, image) => {
    createDrillsCategory({
      title,
      parent_id: parentId,
      image,
    })
  }

  const Categories = ({ depth, parentId, currentClubUuid }) => (
    <>
      {drillsCategoriesState
        .filter(
          (category) =>
            category.parent_id === parentId &&
            category.club_uuid === currentClubUuid
        )
        .map((category) => (
          <Fragment key={category.id}>
            <CategoryForManageCategories
              depth={depth}
              category={category}
              activeLocale={activeLanguage.code}
              updateCategory={updateDrillsCategory}
              deleteCategory={deleteDrillsCategory}
            />
            {depth < MAX_DEPTH && (
              <Categories
                depth={depth + 1}
                parentId={category.id}
                currentClubUuid={currentClubUuid}
              />
            )}
          </Fragment>
        ))}
      <CategoryForManageCategories.New
        depth={depth}
        addNewCategory={addNewCategory(parentId)}
      />
    </>
  )

  Categories.defaultProps = {
    parentId: null,
  }

  Categories.propTypes = {
    depth: PropTypes.number.isRequired,
    parentId: PropTypes.number,
    currentClubUuid: PropTypes.string.isRequired,
  }

  return (
    <Card>
      <Card.Title className="d-flex justify-content-between">
        <SubLink to={linkBack} isFullPath>
          <IconButton edge="start" color="inherit">
            <ArrowBackIcon fontSize="inherit" />
          </IconButton>
        </SubLink>
        <div>
          <Translate id="drills.manage-categories" />
          <LanguageSelectorForAdmins />
        </div>
      </Card.Title>
      <Table>
        <TableBody>
          <Categories depth={0} parentId={null} currentClubUuid={clubUuid} />
        </TableBody>
      </Table>
    </Card>
  )
}

DrillsCategoriesContainer.defaultProps = {
  drillsCategories: [],
}

DrillsCategoriesContainer.propTypes = {
  location: PropTypes.shape({
    fromUrl: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  drillsCategories: PropTypes.arrayOf(PropTypes.shape()),
  createDrillsCategory: PropTypes.func.isRequired,
  updateDrillsCategory: PropTypes.func.isRequired,
  deleteDrillsCategory: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
  clubUuid: PropTypes.string.isRequired,
}

export default compose(
  connect(
    ({
      drills: {
        current: { drillsCategories },
      },
      clubs,
    }) => ({
      drillsCategories,
      clubUuid: clubs.current.uuid,
    }),
    {
      createDrillsCategory: drills.createDrillsCategory,
      updateDrillsCategory: drills.updateDrillsCategory,
      deleteDrillsCategory: drills.deleteDrillsCategory,
    }
  ),
  withLocalize
)(DrillsCategoriesContainer)
